import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const api = axios.create({ baseURL: `${BACKEND}/api` });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("sn_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});
api.interceptors.response.use(
  (r) => r,
  (e) => {
    if (e.response?.status === 401 && !e.config.url.includes("/auth/login")) {
      localStorage.removeItem("sn_token");
      const base = window.location.host.toLowerCase().match(/^admin\.|emergent|^localhost|^127\./) ? "" : "/admin";
      if (window.location.pathname !== `${base}/login`) window.location.href = `${base}/login`;
    }
    return Promise.reject(e);
  }
);

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return String(d);
}

export const STAGES = [
  { key: "not_reviewed", label: "Not Reviewed", n: 0 },
  { key: "cold_email", label: "Cold Email", n: 1 },
  { key: "followup_1", label: "Focused Follow-up", n: 2 },
  { key: "followup_2", label: "Focused Follow Up 2", n: 3 },
  { key: "close_lead", label: "Close Lead", n: 4 },
];
export const CATEGORIES = [
  "Aerospace, Defence & Security", "Agriculture, Fishing & Forestry", "Arts, Culture & Entertainment", "Automotive & Motor Services",
  "Business & Facilities Services", "Business Consultancy", "Charities, Community & Associations", "Construction & Property",
  "Education, Training & Libraries", "Energy & Utilities", "Environmental & Waste Services", "Finance, Accounting & Insurance",
  "Health, Wellbeing & Leisure", "Hospitality & Tourism", "Individual Members", "Industry, Manufacturing & Engineering",
  "IT, Software & Telecommunications", "Legal Services", "Marketing, Media, Print & Design", "Other",
  "Pharmaceutical, Chemical & Medical", "Professional Services", "Public Sector & Government", "Recruitment & Employment",
  "Retail & Wholesale", "Security Services", "Sports & Recreation", "Transport & Logistics",
];
export const CAMPAIGN_STAGES = STAGES.slice(1);
export const stageLabel = (k) => STAGES.find((s) => s.key === k)?.label || k;
export const nextStage = (k) => STAGES[Math.min(STAGES.findIndex((s) => s.key === k) + 1, STAGES.length - 1)].key;
export const fullName = (l) => `${l?.first_name || ""} ${l?.last_name || ""}`.trim();

export function ago(iso) {
  if (!iso) return "never";
  const s = (Date.now() - new Date(iso).getTime()) / 1000;
  const f = Math.abs(s);
  const fmt = f < 60 ? "just now" : f < 3600 ? `${Math.round(f / 60)}m` : f < 86400 ? `${Math.round(f / 3600)}h` : `${Math.round(f / 86400)}d`;
  if (fmt === "just now") return fmt;
  return s >= 0 ? `${fmt} ago` : `in ${fmt}`;
}
export const fmtDate = (iso) => (iso ? new Date(iso).toLocaleString(undefined, { dateStyle: "medium", timeStyle: "short" }) : "—");
